module.exports = {"casino-title":"Mon compte","casino-1":"Téléphone","casino-2":"Modifier mon profil","casino-3":"Produits","casino-4":"Demandes en cours","casino-5":"Dossiers","casino-6":"Quitter"}


//////////////////
// WEBPACK FOOTER
// ./src/companies/casino/lang/fr/user/home.lang.json
// module id = ZPBS
// module chunks = 1